import {
    EntidadePaginadaTabelas,
    TabelaPaginadaComSelecao,
} from '@inovamobil/icm-tabelas';

import { IColuna } from '../types/icm-coluna';

export abstract class IcmServiceTabelaGenerica<
    T,
    Y extends EntidadePaginadaTabelas<T, any>
> extends TabelaPaginadaComSelecao<T, Y> {
    configuracoesColunas: IColuna[];
}
